 export interface StripeCheckout {
    type: string;
    name: string;
    currency: string;
    amount: number;
    mobileNo:boolean;
    shippingAddress: boolean;
    billingAddress: boolean;
    rememberMe: boolean;
    ctaType:string;
    paymentMode:string;
    stripePaymentMode?: 'subscription' | 'onetime' | 'hybrid';
    description: string;
    freeCredit: number;
    creditOnPurchase: number;
    perApiCreditUsage: number;
    config: {
      publicKey: string;
      secretKey:string;
    }
  }


  export const defaultStripeCheckout: StripeCheckout = {
    type:'stripeCheckout',
    name: 'Stripe Checkout',
    currency: 'USD',
    amount: 10,
    mobileNo:false,
    shippingAddress: false,
    billingAddress: false,
    rememberMe: false,
    ctaType:'CTA',
    paymentMode:'Test',
    stripePaymentMode: 'onetime',
    description: 'Default Payment Description',
    freeCredit: 0,
    creditOnPurchase: 0,
    perApiCreditUsage: 1,
    config: {
      publicKey: '',
      secretKey: '',
    }
   
  };


  export interface Sensepass {
    type: string;
    name: string;
  }


  export const defaultSensepass: Sensepass = {
    type:'sensepass',
    name: 'Sensepass',
 
  };
  


  

